<div style="display:flex; flex-direction: column; background: #fff;border-radius: 0.5rem; min-height: 7rem" class="p-2 mt-2">
        <span style="display: flex;align-items: center;" class="fw-medium pb-2 fs-6">
          <svg style="background-color: #A40909" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <g clip-path="url(#clip0_1129_2571)">
              <path
                d="M4.18557 4H11.2938V2H4.18557C3.06856 2 2.15464 2.9 2.15464 4V11H4.18557V4ZM10.2784 13L6.21649 18H18.4021L15.3557 14L13.2943 16.71L10.2784 13ZM17.3866 8.5C17.3866 7.67 16.7062 7 15.8634 7C15.0206 7 14.3402 7.67 14.3402 8.5C14.3402 9.33 15.0206 10 15.8634 10C16.7062 10 17.3866 9.33 17.3866 8.5ZM20.433 2H13.3247V4H20.433V11H22.4639V4C22.4639 2.9 21.55 2 20.433 2ZM20.433 20H13.3247V22H20.433C21.55 22 22.4639 21.1 22.4639 20V13H20.433V20ZM4.18557 13H2.15464V20C2.15464 21.1 3.06856 22 4.18557 22H11.2938V20H4.18557V13Z"
                fill="white"/>
            </g>
            <defs>
              <clipPath id="clip0_1129_2571">
                <rect width="24.3711" height="24" fill="white" transform="translate(0.123711)"/>
              </clipPath>
            </defs>
          </svg>
          <span class="ps-1">Attachments</span>
        </span>
  <mat-divider></mat-divider>
  <div class="pt-2 flex flex-column gap-2">
    <div class="flex justify-content-between px-1" *ngFor="let file of patientData.files;" (click)="downloadFile(file)">
      <span class="flex-1"><i class="pi pi-file"></i> <span class="file p-1 " pTooltip="Download file"
                                                            tooltipPosition="top"> {{ file.name }} </span> </span>
      <span class="flex-shrink-1" pTooltip="View file" tooltipPosition="top"><i
        class="pi pi-eye cursor-pointer"></i></span>
      <br/>
    </div>
    <span *ngIf="!patientData.files.length"> No Files Found</span>
    <div style="display: flex; justify-content: flex-end; align-items: center"></div>
  </div>
</div>
